import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, Lock } from 'lucide-react';

export const TrustSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto space-y-12">
          {/* Client Protection */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                YOUR FUNDS ARE PROTECTED WITH SEGREGATED ACCOUNTS
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                At TD Capital, client fund security is paramount. We maintain strict segregation of client funds 
                from company operational accounts, held with reputable tier-1 banking institutions. This ensures 
                your trading capital is always protected and readily accessible. Our transparent practices include 
                negative balance protection, ensuring you never lose more than your deposited amount.
              </p>
              <Button className="btn-premium text-white font-semibold">
                Open Live Account
              </Button>
            </div>
            <Card className="order-1 lg:order-2 p-8 bg-white border-gray-200">
              <div className="flex items-center justify-center">
                <div className="w-32 h-32 bg-primary/10 rounded-full flex items-center justify-center">
                  <Shield className="h-16 w-16 text-primary" />
                </div>
              </div>
            </Card>
          </div>

          {/* Enterprise Security */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <Card className="p-8 bg-white border-gray-200">
              <div className="flex items-center justify-center">
                <div className="w-32 h-32 bg-primary/10 rounded-full flex items-center justify-center">
                  <Lock className="h-16 w-16 text-primary" />
                </div>
              </div>
            </Card>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                TRADE WITH CONFIDENCE: ENTERPRISE-GRADE SECURITY INFRASTRUCTURE
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Your security is our top priority. TD Capital employs military-grade 256-bit SSL encryption, 
                multi-factor authentication, and real-time fraud detection systems. Our infrastructure is built on 
                segregated client fund architecture with tier-1 banking partners, ensuring your capital remains 
                protected 24/7. We continuously monitor and upgrade our cybersecurity defenses against evolving threats.
              </p>
              <Button className="btn-premium text-white font-semibold">
                Open Live Account
              </Button>
            </div>
          </div>
        </div>

        {/* Media Reviews */}
        <div className="mt-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Highly Praised By
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-6">
            {[
              { name: 'Regional Finance Weekly', rating: '4.8 / 5' },
              { name: 'Trader Community Hub', rating: '4.6 / 5' },
              { name: 'LP Insider Network', rating: '4.7 / 5' },
              { name: 'Market Watch Circle', rating: '4.5 / 5' },
              { name: 'Investment Guild', rating: '4.4 / 5' },
              { name: 'Broker Review Collective', rating: '9.1 / 10' },
              { name: 'Trading Desk Daily', rating: '88 / 100' },
            ].map((media, index) => (
              <Card key={index} className="p-4 text-center hover:shadow-lg transition-shadow border-gray-200">
                <div className="font-bold text-primary text-lg mb-1">{media.rating}</div>
                <div className="text-sm text-gray-600">{media.name}</div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;